import { anchorLink } from "../include/module";
import { navSticky } from "../include/module";
import { spMenu } from "../include/module";
import { placeNav } from "../include/module";
import { preLoad } from "../include/module";





(() => {

  preLoad();

  anchorLink();

  navSticky();

  spMenu();

  placeNav();



  let artistList = Array.prototype.slice.call(document.querySelectorAll('.art-Contents_Artist_Flex'),0); // 12個(indexArrayと同じ数)
  let artistLink = Array.prototype.slice.call(document.querySelectorAll('.sw-Submenu_Item a'),0);
  // console.log(artistList);
  let targetResponsesource = [];                                    // 取得したjsonを格納する配列
  let targetResponse = [];                                    // 取得したjsonを格納する配列
  let targetUrl      = '../assets/json/artist/data.json';     // 現在のURLから見たjsonの位置

  let indexArray  = ['あ', 'か', 'さ', 'た', 'な', 'は', 'ま', 'や', 'ら', 'わ', '英字', '記号'];

  let addItemflag = "";

  window.addEventListener('load', () => {
    if(artistList[0]) {
      readData();
    }
  }, false);



  // ---------------------------------------------------------------------------
  // @function readData
  // jsonのデータを非同期で取得する関数
  // ---------------------------------------------------------------------------
  const readData = () => {
    let x = new XMLHttpRequest();
    x.onreadystatechange = function() {
      if (x.readyState === 4) {
        if (x.status === 200) {
          targetResponse = x.response; // 非同期でファイルを取得できたら格納用の配列に格納
          // IE11の場合パース
          if (JSON) {
            if (navigator.userAgent.indexOf('Trident') !== -1) {
              targetResponse = JSON.parse(targetResponse);
            }
          }
          // targetResponse.sort(function(a,b){
          //   if( a.nameJapanese < b.nameJapanese ) return -1;
          //   if( a.nameJapanese > b.nameJapanese ) return 1;
          //   return 0;
          // });
          renderData();                // 取得したデータを表示
        }
      }
    };
    x.open('GET', targetUrl);
    x.responseType = 'json';
    x.send();
  };



  // ---------------------------------------------------------------------------
  // @function renderData
  // 取得したデータを出力する関数
  // ---------------------------------------------------------------------------
  const renderData = () => {
    targetResponse.forEach((value, index) => {   // 配列の要素1つずつへの処理
      let dataNameEnglish  = value.nameEnglish;  // 変数の定義_英語名
      let dataNameJapanese = value.nameJapanese; // 変数の定義_日本語名
      let dataIndex        = value.index;        // 変数の定義_あかさたな...
      let dataTag          = value.tag;          // 変数の定義_出演カテゴリ
      let dataTagHtml = "";
      if(dataTag) {
        dataTagHtml = '<figcaption>' + dataTag + '</figcaption>'
      }
      let item = document.createElement('li');   // 追加するli要素の生成
      item.classList.add('art-Contents_Artist_Item');    // 追加するli要素にクラス名を追加
      item.innerHTML = `
        <a class="item-anchor" href="../artist/${dataNameEnglish}/">
          <figure class="art-Contents_Artist_Image">
            <img src="../assets/images/artist/img_${dataNameEnglish}.jpg?d=20191017" width="150" height="150" alt="${dataNameJapanese}">
            ${dataTagHtml}
          </figure>
          <p class="art-Contents_Artist_Name">${dataNameJapanese}</p>
        </a>
      `;
      artistList.forEach((blockValue, blockIndex) => {
        if (indexArray[blockIndex] == dataIndex) {
          blockValue.appendChild(item);          // 該当のindex(あかさたな...)のul要素直下であれば表示
        }
      });
    });
    // *************************************************************************
    artistList.forEach((value, index) => {
      if (!value.hasChildNodes()) {
        value.classList.add('isHidden');                        // display: none;
        value.previousElementSibling.classList.add('isHidden'); // display: none;
        value.parentNode.classList.add('isHidden'); // display: none;
        artistLink[index].classList.add('isDisabled');       // pointer-events: none; color: (クリックできないことがわかる色);
      }
    });
    // *************************************************************************
  };
})();



// WEBPACK FOOTER //
// ./src/assets/js/artist/script.js